<template>
  <div class="px-4 py-4">
    <div>
        <p>
          For each lineage we calculate effect size, the difference between that lineage and all others, and p-values based on a t-test. 
          <br><br>
          In order to allow for analysis of relationships at particular doses and overall, T-tests are done at each dose <span v-html="doseMetrics"></span>. The dose or curve-level statistic used for correlation is noted in the “Dose” column.
          <br><br>
          The q-values (a corrected significance value accounting for false discovery rate) are computed from p-values using the
          <a href="https://www.jstor.org/stable/2346101" target="Benjamini_Hochberg">Benjamini-Hochberg algorithm.</a>
        </p>
    </div>
  </div>
</template>

<script>
import * as portalContent from '@/js/models/portal-content.js';
export default {
  name: 'lineage-enrichment-drawer',
  props: {
  },
  data: () => ({

  }),
  computed:{
    meta(){
          const section_id = "lineage-enrichment";
          const screen = this.$route.params.screen;
          const version_meta = portalContent.getVersionMetadata(screen, section_id);
          return version_meta
        },
        doseMetrics(){
          return portalContent.getIncludedDoseMetrics(this.meta)
        }
  },
  mounted() {

  },
  methods: {},
  watch: {}
}
</script>

<style scoped>


</style>
